module.exports = __webpack_public_path__ + "img/vote_gold.0ebd0791.png";